if (!customElements.get('marquee-component')) {
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
      this.handleResize = this.handleResize.bind(this);
      this.resizeTimeout = null;
    }

    connectedCallback() {
      this.setupMarquee();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.setupMarquee(true);
      }, 200);
    }

    setupMarquee(isResize = false) {
      const track = this.querySelector('.marquee-track');
      const wrapper = this.querySelector('.modern-marquee');

      if (!track || !wrapper) return;

      if (isResize) {
        track.style.animation = 'none';
        [...track.children].forEach(child => {
          if (child.dataset.clone === 'true') {
            child.remove();
          }
        });
      }

      const speed = parseFloat(this.getAttribute('data-speed')) || 50;
      const direction = this.getAttribute('data-direction') || 'left';
      const pauseOnHover = this.getAttribute('data-pause-on-hover') !== 'false';

      const originalItems = [...track.children];
      const containerWidth = this.offsetWidth;
      let contentWidth = track.scrollWidth;

      while (contentWidth < containerWidth * 2) {
        originalItems.forEach(item => {
          const clone = item.cloneNode(true);
          clone.dataset.clone = 'true';
          track.appendChild(clone);
        });
        contentWidth = track.scrollWidth;
      }

      const totalDistance = contentWidth / 2;
      const duration = totalDistance / speed;
      const animationName =
        direction === 'right' ? 'scroll-right' : 'scroll-left';

      track.offsetHeight;

      track.style.animation = `${animationName} ${duration}s linear infinite`;

      if (pauseOnHover) {
        wrapper.onmouseenter = () => {
          track.style.animationPlayState = 'paused';
        };
        wrapper.onmouseleave = () => {
          track.style.animationPlayState = 'running';
        };
      }
    }
  }

  customElements.define('marquee-component', MarqueeComponent);
}
